import { render, staticRenderFns } from "./CommercialReleaseDetails.vue?vue&type=template&id=b437dec6&scoped=true"
import script from "./CommercialReleaseDetails.vue?vue&type=script&lang=js"
export * from "./CommercialReleaseDetails.vue?vue&type=script&lang=js"
import style0 from "./CommercialReleaseDetails.vue?vue&type=style&index=0&id=b437dec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b437dec6",
  null
  
)

export default component.exports